import React from "react";
import { Text, useMantineTheme } from "@mantine/core";

interface MainTextProps {
  children: React.ReactNode;
  size?: "xs" | "sm" | "md" | "lg" | "xl";
  className?: string;
  style?: React.CSSProperties;
}

/**
 * MainText - Primary text component with warm ivory color
 * Usage: <MainText>Your main content text</MainText>
 */
export const MainText: React.FC<MainTextProps> = ({
  children,
  size = "md",
  className,
  style,
}) => {
  const theme = useMantineTheme();
  const other = theme.other as Record<string, string>;

  return (
    <Text
      size={size}
      className={className}
      style={{
        color: other.textPrimary,
        lineHeight: 1.6,
        ...style,
      }}
    >
      {children}
    </Text>
  );
};

export default MainText;
